export default function isFractionalNumber (num) {
  return num % 1 !== 0
}
